<div class="content">
	<div *ngIf="datafiles">
		<table class="datafile-table">
			<tr>
				<th>Filename</th>
				<th>Size</th>
				<th>File Type</th>
				<th>Import Date ▼</th>
			</tr>
			<tr *ngFor="let datafile of datafiles; let i = index" class="listing-item" [class.dayspacer]="(datafiles.length > i + 1) && (datafile.imported.clone().startOf('day') > datafiles[i + 1].imported.clone().startOf('day'))">
				<td><a (click)="DownloadFile(datafile)" href="javascript:void(0)"><i class="icon-doc"></i> {{datafile.filename | truncatedfile}}</a></td>
				<td>{{ datafile.size | filesize }}</td>
				<td>{{ datafile.filetype }}</td>
				<td>{{ datafile.imported | datetime : "local" }}</td>
			</tr>
		</table>
	</div>
</div>